import { render, staticRenderFns } from "./SalesPaymentMailModalContent.vue?vue&type=template&id=fe5483ee"
import script from "./SalesPaymentMailModalContent.vue?vue&type=script&lang=js"
export * from "./SalesPaymentMailModalContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports